import { render, staticRenderFns } from "./_base-card-link.vue?vue&type=template&id=3a457b99&scoped=true"
import script from "./_base-card-link.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-card-link.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-card-link.vue?vue&type=style&index=0&id=3a457b99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a457b99",
  null
  
)

export default component.exports